import React from 'react';
var Banner = function (props) {
    var text = props.text, type = props.type;
    var bannerClass = function () {
        switch (type) {
            case 'error': return 'sdds-banner-error';
            case 'info': return 'sdds-banner-info';
            default: return '';
        }
    };
    return (React.createElement("div", { className: "sdds-banner ".concat(bannerClass()) },
        React.createElement("span", { className: "sdds-banner-prefix" },
            React.createElement("svg", { width: "16", height: "17", viewBox: "0 0 16 17", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg" },
                React.createElement("rect", { y: "0.334473", width: "16", height: "16" }))),
        React.createElement("div", { className: "sdds-banner-body" },
            React.createElement("h6", { className: "sdds-banner-header" }, text))));
};
Banner.defaultProps = {
    type: null,
};
export default Banner;
